export { default } from "./TeamPlayerAvatar";
